
class OptionVariantSelector extends VariantSelector {
  constructor() {
    super();
    this.property = this.getAttribute('variant-option');
    this.value = false;
    this.displayValue = false;
    this.unavailableLabel = this.getAttribute('unavailable-label');
    this.formId = this.getAttribute('form-id');
    this.options = '';
    this.wrapper = this.querySelector(`.product-${this.property}-selector`);
    this.tooltip = this.querySelector(`.product-${this.property}-selector__tooltip`);
    this.label = this.querySelector(`.product-${this.property}-selector__label`);
    this.unavailableTooltip = this.getAttribute('unavailable-tooltip') || null;
    this.unavailableTooltipMobile = this.getAttribute('unavailable-tooltip-mobile') || null;
    this.inlineMsg = null;
    this.enableTooltip = this.getAttribute('enable-tooltip') !== 'false';
    this.enableSnackbar = this.getAttribute('enable-snackbar') !== 'false';
  }

  getAvailabilityClass(option) {
    return option.enabled ? '' : 'soft-unavailable';
  }

  render() {
    const options = window.variants.getVariantData(this.property);
    let markup = '';

    options.forEach((value) => {
      const selectorID = `selector-${this.property}-option-${value.dynamicHandle}`;
      const availClass = this.getAvailabilityClass(value);

      markup += `<a class="product-form__input-wrapper button-text" href="${this.getAttribute('url-root')}/${value.dynamicHandle}">
        <input id="${selectorID}" type="radio" form="${this.formId}" name="${this.property}-option" value="${value.value}" class="p-small ${availClass}" selected="false" aria-disabled="${!value.enabled}" />
        <label for="${selectorID}" class="p-small">
          <span class="">${value.label}</span>
          <span class="visually-hidden sr-unavailable">${!value.enabled ? this.unavailableLabel : ''}</span>
          <svg><line x1="0" y1="98%" x2="100%" y2="2%"></line></svg>
        </label>
      </a>`
    });

    this.wrapper.insertAdjacentHTML('beforeend', markup);

    this.wrapper.classList.toggle('hidden', options.length === 0);

    this.wrapper.querySelectorAll('a.product-form__input-wrapper').forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        const input = element.querySelector('input[type="radio"]');

        // Already selected — do nothing
        if (input && input.value === this.value) {
          return;
        }

        const state = input ? this.getOptionState(input.value) : null;

        // Soft-unavailable — show snackbar (deferred; navigation carries state), then resolve
        if (state?.softUnavailable) {
          this.showVarPickerSnackbar(true);
          window.variants.resolveConflict(this.property, input.value);
        }

        // Replace history entry and navigate
        window.location.replace(element.href);
      });
    });

    // Inline message element (mobile only — hidden on desktop via CSS)
    const inlineMsg = document.createElement('p');
    inlineMsg.className = 'varpicker-inline-message';
    inlineMsg.setAttribute('aria-live', 'polite');
    this.wrapper.insertAdjacentElement('afterend', inlineMsg);
    this.inlineMsg = inlineMsg;

    // Wire variant picker listeners
    this.setupVarPickerHover();
    this.setupVarPickerTapMessage();
  }

  setValue(value){
    super.setValue(value);
    const selected = this.querySelector(`[name="${this.property}-option"][value="${value}"`);
    selected.checked = true;
    this.updateLabel();
  }

  updateOptions(event){
    if (event.detail.property != this.property){
      const options = window.variants.getVariantData(this.property);

      for (var option in options){
        const input = this.querySelector(`input[value="${options[option].value}"]`);
        const label = input.nextElementSibling.querySelector('span.sr-unavailable');
        const availClass = this.getAvailabilityClass(options[option]);

        // Remove all availability classes before applying current state
        input.classList.remove('disabled', 'soft-unavailable');

        if (options[option].enabled){
          label.innerHTML = '';
        } else {
          input.classList.add(availClass);
          label.innerHTML = this.unavailableLabel;
        }
        input.setAttribute('aria-disabled', !options[option].enabled);
      }
      this.updateUrls();
    }
  }

  updateSelected(event) {
    if (event.detail.property == this.property){
      const selected = this.querySelector(`[name="${this.property}-option"][value="${event.detail.code}"]`);
      if (selected){
        selected.checked = true;
        this.updateLabel();
      }
    }
  }

  updateLabel() {
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.displayValue = this.querySelector(`label[for="${selected.id}"] span:first-child`).textContent;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`
    this.label.innerHTML = this.displayValue;
  }


  updateUrls(){
    const baseUrl = `${this.getAttribute('url-root')}`;

    let params = new URLSearchParams(window.location.search);

    const stripParams = ['width', 'variant'];
    stripParams.forEach((value) => {
      if (params.get(value)){
        params.delete(value);
      }
    });

    const qs = params.toString();
    const options = window.variants.getVariantData(this.property);
    options.forEach((option) => {
      const element = this.querySelector(`[value="${option.value}"]`);
      if (!element.parentElement) return;
      const handle = option.enabled ? option.dynamicHandle : option.staticHandle;
      element.parentElement.setAttribute('href', `${baseUrl}/${handle}?${qs}&width=${option.value}`)
    });
  }
}

customElements.define('option-variant-selector', OptionVariantSelector);
